/*
 * @Author: 卷柏 1350797548@qq.com
 * @Date: 2024-04-30 16:59:51
 * @LastEditors: luxian luxian@micous.com
 * @LastEditTime: 2024-12-21 16:19:21
 * @FilePath: \pc\coursearrange\config\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */


let apiBaseUrl = ''

// 本地/内网开发:跟随访问主机直连后端 7101(localhost 或 192.168.x.x/10.x.x.x/172.16-31.x.x);
// 生产部署(阿里云,公网 IP 或域名,nginx 反代 /api):走同源相对路径,自动适配 http/https。
if (typeof window !== 'undefined') {
  var _h = window.location.hostname
  var _isPrivate = _h === 'localhost' || _h === '127.0.0.1' ||
    /^192\.168\./.test(_h) || /^10\./.test(_h) || /^172\.(1[6-9]|2[0-9]|3[01])\./.test(_h)
  apiBaseUrl = _isPrivate ? ('http://' + _h + ':7101') : '/api'
} else {
  apiBaseUrl = '/api'
}

// 新环境
// apiBaseUrl = 'http://8.140.206.45/api';

//生产正式环境
// http://121.89.90.216/
// apiBaseUrl = 'http://121.89.90.216/api';
// apiBaseUrl = 'https://www.mzkt.top/api';

//测试环境
// apiBaseUrl = 'https://gogocoder.com/api';
// apiBaseUrl = 'https://120.26.3.61:80/api';

//本地环境
// apiBaseUrl = 'http://localhost:7101';


// 后台调式 -----
// apiBaseUrl = 'http://192.168.0.132:7101';

// 后台调式 ----
// apiBaseUrl = 'http://192.168.0.112:7101';

// apiBaseUrl = 'http://192.168.0.110:7101';

export default apiBaseUrl;






//////////////////
// WEBPACK FOOTER
// ./config/api.js
// module id = IYyn
// module chunks = 3